import axios from '@/services/api';


export const getTopics = async ({ commit }) => {

    const response = await axios.get('/topics')

    const { data } = response;

    try {
        if (data) {
            commit('setTopics', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getTopicById = async ({ commit }, id) => {
    commit('setCurrentTopic', null);
    const response = await axios.get(`/topics/${id}`)

    const { data } = response;

    try {
        if (data) {
            commit('setCurrentTopic', data);
        }

    } catch (e) {
        console.log(e);
    }
}

export const add = async (_, payload) => {

    return await axios.post("topics", payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const edit = async (_, payload) => {

    return await axios.put("topics/" + payload['id'], payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const deleteTopic = async ({commit}, id) => {

    await axios.delete(`/topics/${id}`)
    try {
        commit('setLoading', false);
    } catch (e) {
        console.log(e);
    }
};
